@if (visible()) {
  <div class="ui-alert ui-alert--{{ type() }}" role="alert">
    <div class="ui-alert__content">
      @if (title()) {
        <strong class="ui-alert__title">{{ title() }}</strong>
      }
      <div class="ui-alert__body"><ng-content /></div>
    </div>
    @if (dismissible()) {
      <button
        type="button"
        class="ui-alert__close"
        (click)="dismiss()"
        aria-label="Fermer"
      >
        ✕
      </button>
    }
  </div>
}
